import BursaryLayout from "./BursaryLayout";
import adminImage from '../../../assets/Dashboard/main-admin.svg';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import SubLoading from '../../Loading/SubLoading';

const BursaryDashboard = ({ admins, auth }) => {
    let output;
    if(auth.uid) {
        let admin;
        
        if (admins) {
            
            admin = admins.filter((item) => {
                return item.id === auth.uid
            });  
            
            output = admin[0];     //console.log(output, auth);
            
        }     
    }
    
    return ( 
        <BursaryLayout>
            <div className="section">
                <div className="container">
                    <div className="dashboard center">
                        {
                            output ? (
                                <>
                                    <h4 className="is-size-5-touch is-size-4-desktop mt-6 mb-4 has-text-weight-semibold grey-text text-darken-3">Welcome {output.title} {output.surname} to the Bursary dashboard.</h4>
                                    <div className="dashboard-illustration container">
                                        <img src={adminImage} alt="Illustration" />
                                    </div>
                                </>
                            ) : (
                                <SubLoading />
                            )
                        }
                        
                    </div>
                </div>
            </div>
        </BursaryLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth,
    }
    
}

export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(BursaryDashboard);
